import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/app/store';
import Button from 'src/components/Order/Button';
import Header from 'src/components/Order/HeaderComponent';

export default function OrderConfirm() {
  const { t } = useTranslation(['main']);
  const navigate = useNavigate();
  const { titleHeader } = useAppSelector(state => state.order);
  const handleBack = () => {
    navigate('../index', {
      relative: 'path',
    });
  };

  return (
    <div className="font-medium h-[calc(83vh-40px)] overflow-y-none mb-[-17%]">
      <div className="top-0 z-20 left-0 fixed px-[15px] pt-[12px] w-full scroll-smooth font-medium shadow-md bg-white">
        <Header title={titleHeader} isShowBack={false} isShowMenu={true} />
      </div>
      <div className="h-[calc(100%-115px)] flex flex-col items-center justify-center gap-5">
        <img src="../../tick.svg" alt="tick" className="w-[100px] animate-rotation" />
        <h1>{t('orderConfirmSuccess')}</h1>
      </div>
      <div className="font-medium border-t-[1.5px] border-solid border-shadow-2 bg-white pt-5 pb-5 fixed bottom-0 left-0 w-full px-[5%]">
        <Button
          variant="secondary"
          image="../../whatsapp.png"
          onClick={handleBack}
          label="Claim Points"
          className="font-medium mb-5"
        />
        <Button
          className="px-5 w-full py-2 text-[16px]"
          onClick={handleBack}
          label="Back to Order"
        />
      </div>
    </div>
  );
}
